import { AxiosError } from 'axios'
import { LoadState } from '@/store'
import {
  Item,
  AdditiveItem,
  ErrorData,
  ClientPack,
  Cost,
  DeliveryMethods,
  PropositionItem,
  PromocodeType,
  Gift,
} from '@/api/modules/basket/types'
import { ChangeChoices } from '@/types/api/api-v3/basket'
import { BasketPayment } from '@/types/api/api-v3/paymentMethods'

export type BasketState = LoadState<Basket, AxiosError<ErrorData>>

export interface Basket {
  totalPrice: number
  totalAmount: number
  amountToPay: number
  itemsCount: number
  items: Item[]
  additives: AdditiveItem[]
  maxNumberOfPersons: number
  persons: Persons
  promocode: Promocode
  delivery: {
    cost: Cost | null
    method: DeliveryMethods
    addresses: {
      [K in DeliveryMethods]: number | string | null
    }
  }
  gifts: Gift[]
  bonuses: Bonuses
  selectedPaymentMethod: BasketPayment | null
  note: string
  change: number
  proposition: Proposition
  clientPacks: ClientPack[]
  doNotCallMeBack: boolean
  isExtra: boolean
}

export interface Persons {
  errorMessage: string
  helpMessage: string
  maxNumber: number | null
  message: string
  number: number | null
}

export interface Promocode {
  discountAmount: number
  title: string
  value: string
  valid: boolean
  error: string
  type: PromocodeType | null
}

export interface Bonuses {
  toSpendAmount: number
  maxSpendAmount: number
  toAccrueAmount: number
  totalAmount: number
  errorMessage: string
  message: string
}

export interface Proposition {
  timeToLive: number
  popupText: string
  items: PropositionItem[]
}

export interface ChangeState {
  choices: ChangeChoices[]
  quantitySelectedProducts: Record<number, number>
}

export interface TimeState {
  delivery_at: string
  delivery_at_text: string
  error: string
  choices: DateTimeChoices[]
  message: string
  variants: TimeVariants[]
  warning: string
  warning_icon: string
  selectedTimeMethod: TimeMethod
}

export interface TimeVariants {
  delivery_at_choice: string
  delivery_at_text: string
  delivery_at: string
}

export interface DateTimeChoices {
  text: string
  value: string
}

export enum TimeMethod {
  AVAILABLE_TIME = 'AVAILABLE_TIME',
  ON_TIME = 'ON_TIME',
}
export interface SetTimePayload {
  delivery_at_client: boolean
  delivery_at?: string
}
